<template>
    <div class="navMenu">
        <div class="navMenuTop">
            <div class="content">
                <div class="content2">
                    <img class="publicLogo" src="~assets/img/logo.png" alt="">
                    <span>国际高等教育平台</span>
                </div>
                <el-input
                    placeholder="请输入关键字搜索（学校、位置）"
                    v-model="search"
                    suffix-icon="el-icon-search" 
                    class="mobileSearch"
                    @change=searchClick>
                </el-input>
                <div class="mLine"></div>
                <div class="mSearchBtn" @click="searchClick"></div>
                <el-input
                    class="searchInput"
                    placeholder="请输入关键字（学校、位置）"
                    v-model="search"
                    prefix-icon="el-icon-search"
                    clearable>
                </el-input>
                <el-button type="primary" size="medium" class="searchBtn" @click="searchClick()">搜索</el-button>
                <div class="personInfo" v-show="isShowInfo">
                    <div class="block"><el-avatar :size="30" :src="circleUrl"></el-avatar></div>
                    <div class="infoName">
                        <el-dropdown @command="goPage">
                            <div class="el-dropdown-link">
                                <span class="userName">{{userName}}</span>
                                <i class="el-icon-arrow-down el-icon--right"></i>
                            </div>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item command="/profile">我的资料</el-dropdown-item>
                                <el-dropdown-item command="/myOrder">我的订单</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </div>
                    <div class="outLogin" @click="outLogin">退出</div>
                </div>
                <div class="personInfo login" v-show="!isShowInfo" @click="login">
                    登录
                </div>
                <div class="selectMenu">
                    <el-dropdown @command="goLanguage">
                        <span class="el-dropdown-link">
                            学习专区<i class="el-icon-arrow-down el-icon--right"></i>
                        </span>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item command="1">培训系统登录</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </div>
                <div class="showMobile mMenu">
                    <el-dropdown @command="goPage" trigger="click" :hide-on-click="true" >
                            <span class="el-dropdown-link">
                                <img class="mMenuImg" src="~assets/img/mMenu.png" alt="">
                            </span>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item command="/profile">我的资料</el-dropdown-item>
                                <el-dropdown-item command="/myOrder">我的订单</el-dropdown-item>
                                <!-- <el-dropdown-item ><span @click="outLogin">退出</span></el-dropdown-item> -->
                            </el-dropdown-menu>
                        </el-dropdown>
                </div>
            </div>
        </div>
    </div>
  
</template>

<script>
    import { wxUserInfo, outLogin } from "network/login.js"
    import { checkRealName } from "network/application.js"
    export default {
        data(){
            return {
                circleUrl: "",
                userName:'',
                isShowInfo:false,
                search:''
            }
        },
        created(){
            this.getWxUserInfo()
            this.getCheckRealName()
        },
        methods:{
            goPage(command){
                this.$router.push(command)
            },
            goLanguage(command){
                let url = "https://lms.cdinfotech.cn/login"
                window.open(url, "_blank");
            },
            getWxUserInfo(){
                wxUserInfo().then(res=>{
                    if(res.code == 1){
                        this.circleUrl = res.data.headImg,
                        this.userName = res.data.nickName
                        this.isShowInfo = true
                        localStorage.setItem('wxUserId',res.data.id)
                        this.$store.dispatch('getChangLoginState',true)
                    }else{
                        this.isShowInfo = false
                        this.$store.dispatch('getChangLoginState',false)
                    }
                })
            },
            // 查真实姓名及手机号是否填写
            getCheckRealName(){
                checkRealName().then(res=>{
                    if(res.code == 1){
                        this.$store.dispatch('getChangRealNameState',true)
                    }else if(res.code == 2){
                        this.$store.dispatch('getChangRealNameState',false)
                    }
                })
            },
            // 退出
            outLogin(){
                outLogin().then(res=>{
                    this.$message({
                        type:'success',
                        message:res.msg
                    })
                    this.getWxUserInfo()
                    this.goPage('/index')
                })
            },
            // 登录
            login(){
                this.goPage('/login')
                let lastLink = window.location.href;
                sessionStorage.setItem('lastLink',lastLink)
            },
            searchClick(){
                this.$router.push('/schoolList?keyword=' + this.search + '&flag=search')
            }
        }
    }
</script>
<style scoped lang="scss">
.el-button--primary {
    color: #FFF;
    background-color:var(--color-main);
    border-color:var(--color-main);
}
i.defaultColor{
    color:#fff;
    margin-right: 5px;
    width: 24px;
    text-align: center;
    font-size: 18px;
    vertical-align: middle;
}
.content{
    width:1200px;
    margin:0 auto;
    display: flex;
    align-items: center;
    .searchInput{
        width: 500px;
    }
    .searchBtn{
        margin:0 30px 0 10px;
    }
}
.personInfo.login{
    min-width:100px;
}
.personInfo{
    font-size: 16px;
    line-height: 16px;
    min-width: 190px;
    font-weight: normal;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    .infoName{
        margin-left: 15px;
        cursor: pointer;
        .userName{
            display: inline-block;
            max-width: 70px;
            overflow: hidden;
            height: 14px;
            white-space: nowrap;
            text-overflow: ellipsis;
        }
    }
    .outLogin{
        font-size: 14px;
        margin-left:15px;
        cursor: pointer;
        width:39px;
    }
}
.personInfo.login{
    cursor: pointer;
    letter-spacing: 6px;
}
.navMenu{
    position: relative;
    z-index: 11;
}
.navMenuTop{
    font-size: 30px;
    font-weight: bold;
    line-height: 80px;
    width:100%;
    position: fixed;
    top:0px;
    left:0;
    background:#fff;
    color:var(--color-main);
}
.navMenuBot{
    width:100%;
    position: fixed;
    top:80px;
    left:0;
    background: var(--color-main);
}
.navMenuTop .content2{
    display: flex;
}
.content .publicLogo{
    height: 50px;
    margin:auto 30px auto 0;
}
.mobileSearch{
    display:none;
}
.selectMenu{
    font-size: 16px;
    width: 200px;
    line-height: 30px;
    text-align: right;
    font-weight: normal;
    cursor: pointer;
}
@media screen and (max-width: 768px){
   
    .content .publicLogo{
        height: 0.6rem;
        margin:auto 0.4rem auto 0.1rem;
        position: relative;
    }
    .mobileSearch{
        display: block;
        width:80%;
        margin:0 5%;
    }
     .mSearchBtn{
        width:0.7rem;
        height:0.7rem;
        border-radius: 0 0.35rem 0.35rem 0;
        position:absolute;
        right:15%;
        opacity: 0;
        cursor: pointer;
    }
    .mLine{
        width: 1px;
        height: 0.5rem;
        background:#DCDFE6;
        position: absolute;
        right:24%;
    }
    .personInfo,.content2,.selectMenu{
        display: none!important;
    }
    .content{
        width: 100%;
        .searchInput,.searchBtn{
            display: none;
        }
        .mMenu{
            font-size:0.32rem;
            font-weight: normal;
            line-height:0.32rem;
            padding-right:0.2rem;
            .mMenuImg{
                height:0.45rem;
            }
        }
    }
    .navMenuTop .content2{
        justify-content: center;
    }
   
    .navMenuTop{
        height:1rem;
        font-size: 0.38rem;
        line-height: 1rem;
        color:var(--color-text);
        text-align: center;
    }
    .navMenuBot{
        position: fixed;
        top:1rem;
        left:0;
    }
    .menu-mobile>div{
        flex-shrink: 0;
        height: 100%;
        padding:0 0.3rem;
        line-height: 0.9rem;
    }
    
}
</style>